import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import Image from 'next/image'
import styles from './CartIcon.module.css'

type Props = {
  quantity: number
  open: boolean
}

const CartIcon: FunctionComponent<Props> = ({ quantity, open }: Props) => {
  if (open) {
    return (
      <Image
        className={classNames(styles.Fill, styles.Close)}
        height={24}
        width={24}
        src="/static/svg/close-icon.svg"
        alt="close"
        data-testid="sticky-footer-close-button"
      />
    )
  }

  return (
    <svg
      width="28"
      height="40"
      viewBox="0 0 28 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={styles.Fill}
        d="M7.14204 25.1769L3.79247 12.0616H0.128025V10H5.39366L6.18329 13.0917L27.5 13.0765L25.2337 25.1769H7.14204V25.1769ZM6.70966 15.1529L8.74323 23.1154H23.5224L25.0162 15.1398L6.70966 15.1529Z"
      />
      <path
        className={styles.Fill}
        d="M9.96419 32.6897C8.14635 32.6897 6.66743 31.2108 6.66743 29.3929C6.66743 27.5751 8.14635 26.0962 9.96419 26.0962H22.3851C24.2029 26.0962 25.6819 27.5751 25.6819 29.3929C25.6819 31.2108 24.2029 32.6897 22.3851 32.6897C20.5672 32.6897 19.0883 31.2108 19.0883 29.3929C19.0883 28.9564 19.1738 28.5394 19.3286 28.1577H13.0206C13.1755 28.5394 13.261 28.9564 13.261 29.3929C13.2609 31.2108 11.782 32.6897 9.96419 32.6897ZM21.1499 29.3929C21.1499 30.074 21.704 30.6282 22.3851 30.6282C23.0662 30.6282 23.6203 30.074 23.6203 29.3929C23.6203 28.7118 23.0662 28.1577 22.3851 28.1577C21.704 28.1577 21.1499 28.7118 21.1499 29.3929ZM8.72895 29.3929C8.72895 30.074 9.28306 30.6282 9.96416 30.6282C10.6453 30.6282 11.1994 30.074 11.1994 29.3929C11.1994 28.7118 10.6453 28.1577 9.96416 28.1577C9.28306 28.1577 8.72895 28.7118 8.72895 29.3929Z"
      />
      {!!quantity
        && (
          <g className="circle" data-testid="cart-quantity">
            <>
              <circle
                cx="20"
                cy="5"
                r="7"
                className={styles.Fill}
              />
              <text x="20" y="7" className={styles.Quantity}>
                {quantity}
              </text>
            </>
          </g>
        )}
    </svg>
  )
}

export default CartIcon
